import React from 'react';
import { HeroSection } from './sections/HeroSection';
import { ProblemSection } from './sections/ProblemSection';
import { SolutionSection } from './sections/SolutionSection';
import { PricingSection } from './sections/PricingSection';
import { TrustSection } from './sections/TrustSection';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="w-full min-h-screen bg-[#F1F4F8]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <PricingSection data-id="element-4" />
      <TrustSection data-id="element-5" />
      <Footer data-id="element-6" />
      <PurchasePopup data-id="element-7" />
      <StickyMobileCTA data-id="element-8" />
      <MetaPixel data-id="element-9" />
    </div>;
}